/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

import { log } from "../utils/log" // defines globals as side effect ...

// first define defaults
const config = {
  log: {
    enable: true,
    level: "all",
    pingLevel: "all",
  },

  // legacy config for compatibility
  // see webappclient/src/conf/settings.js
  updateType: "WS",
  compressPayload: false, // typeof atob !== "undefined", requires pako, whatever this is
  secureCommunication: false,
  networkOfflineTimeout: 20000,
  websocketInitialConnectTimeout: 5000,
  websocketSendInterval: 100,
  websocketResentThreshold: 15000,
  websocketReconnectWaitTimeMin: 1500,
  websocketReconnectWaitTimeMax: 4000,
  pollIntervalMin: 800,
  pollIntervalMax: 1200,
  pollTimeout: 3000,
}

// todo align this with MAB's config in webmc
// todo import and merge custom config

export default config

export function getConfigParameter(key) {
  let value = config[key]
  if (typeof value !== "undefined") {
    log.trace("config[", key, "] = ", value)
  } else {
    log.warn("config[", key, "] is undefined")
  }
  return value
}
